import { Injectable, Input } from '@angular/core';

@Injectable()
export class ComponentLoaderAbstract<T> {
  @Input() data!: T;
}
